import DriverDetailsRequest from "../../../api/raily/driver/details/driver-details.request";
import DriverDetailsParams from "./driver-details-params";

const create = (params: DriverDetailsParams): DriverDetailsRequest => {
  return {
    driverId: params.driverUuid,
  };
};

const driverDetailsParamsFactory = {
  create,
};

export default driverDetailsParamsFactory;
